module.exports = __webpack_public_path__ + "static/template_options_1_day_with_week_grid-1b3602f04f7970cf8dd322e43af26dc0.png";